import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {DemandValidation} from "constants/DemandValidation";
import Tr from "translations/Translations";
import Button from "components/Button";
import React from "react";
import GridBlock from "../../../../../../../components/GridBlock";

function Questionnaire(
    {
        demandValidation
    }) {

    const findSection = (compareSection) => demandValidation.find(x => x.section === compareSection);

    const section = findSection(DemandValidation.QUESTIONNAIRE);

    const handleClick = () => {
        window.location.href = section.questionnaireTabUrl;
    }

    return (
        <div style={{width: "100%"}}>
            <GridBlock justify="center" alignItems="center">
                <Button onClick={handleClick}>{Tr("move_to_questionnaire_tab")}</Button>
            </GridBlock>
        </div>
    )
}

Questionnaire.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(Questionnaire));